module.exports = __webpack_public_path__ + "img/video.5aba5f8f.png";